import { Button } from '@rappi/rests-commons-front';
import styled from 'styled-components';
export const ButtonStyled = styled(Button) `
  & > div {
    display: grid !important;
    grid-template-columns: max-content 1fr;
    gap: 8px;

    & > div {
      text-align: left;
      text-wrap: nowrap;
    }
  }

  & > div svg {
    margin-right: 0 !important;
  }
`;
export const TableContainer = styled.div `
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
`;
export const conditionalRowStyles = [
    {
        when: (row) => row.ranking === 1,
        style: {
            backgroundColor: '#FFE9BC',
            '&:not(:last-of-type)': {
                borderStyle: 'solid',
                borderColor: '#E9D2AA',
                borderWidth: '1px 0px 1px 0px !important',
            },
        },
    },
    {
        when: (row) => row.ranking === 2,
        style: {
            backgroundColor: '#FFFAEE',
        },
    },
    {
        when: (row) => row.ranking === 3,
        style: {
            backgroundColor: '#FFFAEE',
        },
    },
];
